import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-120" data-mp="x53c6xk9hz9o">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="121tqpggf4msz">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-122" data-mp="122vdgi6sqxqj">
          ❓ Frequently asked questions
        </h2>

        <ul className="mt-9 flex flex-col gap-3" data-id="element-123" data-mp="1uq92zv860r0m">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-navy-100 bg-cream" data-id="element-124" data-mp="1g0jwrll7twth" data-mpi={index}>
                <h3 data-id="element-125" data-mp="28r208npuq07f">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-50" data-id="element-126" data-mp="28qjun0hau9mu">
                    <span className="text-[15px] font-bold leading-snug text-navy-800 sm:text-base" data-id="element-127" data-mp="2jsywkpwbt5ff">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-128" data-mp="2tp1xjsffyy0s" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-navy-100 px-5 py-4 text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-129" data-mp="3hcjsfwu06c7z">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>

        <SectionCta label="I'm ready — get instant access" data-id="element-130" data-mp="1i33ll0n4mnje" />
      </div>
    </section>;
}